import { render, staticRenderFns } from "./c-button-group.vue?vue&type=template&id=56bc6533&scoped=true"
import script from "./c-button-group.vue?vue&type=script&setup=true&lang=js"
export * from "./c-button-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-button-group.vue?vue&type=style&index=0&id=56bc6533&prod&lang=less&scoped=true"
import style1 from "./c-button-group.vue?vue&type=style&index=1&id=56bc6533&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc6533",
  null
  
)

export default component.exports